import styled from 'styled-components'
import { MOBILE_WIDTH } from 'utils/constants'

export const DocumentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  padding: 2rem;

  h2 {
    font-size: 1.125rem;
    font-weight: 400;
    color: #4a5568;
    margin: 1rem 0;

    strong {
      font-weight: 600;
      color: #00607f;
    }
  }

  @media ${MOBILE_WIDTH} {
    padding: 1rem;
  }
`

export const DocumentsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
`

export const LawsuitSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.35rem;
  width: 100%;
  padding: 1.25rem;
  border-radius: 12px;
  border: 1px solid #9fe3e8;
  background: #f0fdff;
`

export const LawsuitTitle = styled.h3`
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #00607f;
`

export const LawsuitText = styled.p`
  margin: 0;
  max-width: 36rem;
  font-size: 0.95rem;
  line-height: 1.45;
  color: #3d3d3d;
`

export const DownloadButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.5rem;
  min-width: 140px;
  padding: 0.7rem 1.25rem;
  border-radius: 8px;
  background: #02b0bb;
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
  text-decoration: none;

  &:hover {
    background: #029aa4;
    color: #fff;
  }

  &:focus-visible {
    outline: 2px solid #00607f;
    outline-offset: 2px;
  }
`

export const LawsuitUnavailable = styled.p`
  margin: 0.35rem 0 0;
  font-size: 0.875rem;
  font-weight: 600;
  color: #6b7280;
`

export const FileInputsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  width: 100%;

  @media ${MOBILE_WIDTH} {
    grid-template-columns: 1fr;
  }
`
